<template>
    <div>
        <b-modal id="affiliate-edit" title="Edit affiliate" :hide-footer="hideFooter">
            <form>
                <div class="form-group">
                    <label for="#bkmName">Affiliate code:</label>
                    <input class="form-control" type="text" placeholder="Ex: Bet365" required="required" v-model="affiliate.affcode">
                </div>
                <div class="form-group">
                  <label for="#bookmakerModal" class="text-info">Select the Bookmaker</label>
                  <select id="bookmakerModal" class="form-control" v-model="affiliate.bookmaker" @change="addANewBookmaker">
                      <option value="0">Select</option>
                      <option v-for="bookmaker in bookmakers" :key="bookmaker._id" :value="bookmaker.code">{{bookmaker.name}}</option>
                      <option class="special" value="addnew">Add a new Bookmaker</option>
                  </select>
                </div>
                <div class="form-group">
                    <label for="#bkmDescription">Affiliate Description:</label>
                    <textarea class="form-control" id="bkmDescription" v-model="affiliate.description"></textarea>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="affiliate.default">
                  <label class="form-check-label">Default code</label>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="updateAffiliate">Update</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  data () {
    return {
      hideFooter: true,
      affiliate: '',
      affiliateID: '',
      affBookmaker: 0,
      bookmakers: ''
    }
  },
  methods: {
    updateAffiliate () {
      if (this.affiliate.description &&
              this.affiliate.affcode &&
              this.affiliate.bookmaker) {
        this.$http.patch(`${this.$api_url}/affcode/edit/` + this.affiliate._id, { affcode: this.affiliate.affcode, description: this.affiliate.description, bookmaker: this.affiliate.bookmaker, default: this.affiliate.default }).then((success, error) => {
          if (success) {
            Bus.$emit('affiliateUpdated', success.data)
            this.$bvModal.hide('affiliate-edit')
          }
          if (error) {
            this.$bvModal.hide('affiliate-edit')
            alert('Something wrong just happened!')
          }
        })
      }
    },
    addANewBookmaker (event) {
      if (event.target.value === 'addnew') {
        Bus.$emit('modalBookmakersOpened')
        this.$bvModal.show('bookmaker-add')
      }
    },
    getBookmakers () {
      this.$http.get(`${this.$api_url}/bookmakers/all`).then((bookmakers) => {
        this.bookmakers = bookmakers.data
      })
    }
  },
  created () {
    Bus.$on('editAffiliate', (affiliateData) => {
      this.getBookmakers()
      this.affiliate = affiliateData
    })
    Bus.$on('reloadBookmakers', (data) => {
      this.getBookmakers()
      this.affiliate.bookmaker = data.code
    })
  },
  beforeDestroy () {
    Bus.$off('editAffiliate')
    Bus.$off('reloadBookmakers')
  }
}
</script>
<style scoped>
</style>
